<template>
  <div>
    <template v-if="pastDueTasks.length">
      <p class="timeframe-title text-uppercase past_due">
        <icon-default icon="past-due"></icon-default>
        Past Due
      </p>

      <lazy-render
        v-for="task in pastDueTasks"
        :key="task.id"
        :min-height="100"
        unrender
      >
        <up-next-task-item
          :store-task="task"
          @edit="openEditTaskModal"
        ></up-next-task-item>
      </lazy-render>
    </template>

    <template v-if="todayTasks.length">
      <p class="timeframe-title text-uppercase today">
        <icon-default icon="today"></icon-default>
        Due Today
      </p>

      <lazy-render
        v-for="task in todayTasks"
        :key="task.id"
        :min-height="100"
        unrender
      >
        <up-next-task-item
          :store-task="task"
          @edit="openEditTaskModal"
        ></up-next-task-item>
      </lazy-render>
    </template>

    <template v-if="tomorrowTasks.length">
      <p class="timeframe-title text-uppercase">
        <icon-default icon="upcoming"></icon-default>
        Due Tomorrow
      </p>

      <lazy-render
        v-for="task in tomorrowTasks"
        :key="task.id"
        :min-height="100"
        unrender
      >
        <up-next-task-item
          :store-task="task"
          @edit="openEditTaskModal"
        ></up-next-task-item>
      </lazy-render>

    </template>

    <template v-if="upcomingTasks.length">
      <p class="timeframe-title text-uppercase">
        <icon-default icon="upcoming"></icon-default>
        Upcoming
      </p>

      <lazy-render
        v-for="task in upcomingTasks"
        :key="task.id"
        :min-height="100"
        unrender
      >
        <up-next-task-item
          :store-task="task"
          @edit="openEditTaskModal"
        ></up-next-task-item>
      </lazy-render>
    </template>

    <!-- Task Modal -->
    <modal-container>
      <modal-crud-form
        ref="taskModal"
        title="Task"
        form-component="task-form"
        is-double-column
      ></modal-crud-form>
    </modal-container>
  </div>
</template>

<script>
import UpNextTaskItem from "./UpNextTaskItem";
import LazyRender from "../../../components/LazyRender";
import dates from "../../../services/dates";

export default {
  name: "UpNextTaskList",
  components: {LazyRender, UpNextTaskItem},
  props: {
    tasks: {
      type: Array,
      required: true
    }
  },
  computed: {
    pastDueTasks() {
      return dates.returnItemsBeforeToday(this.tasks, 'due_at');
    },
    todayTasks() {
      return dates.returnItemsForToday(this.tasks, 'due_at');
    },
    tomorrowTasks() {
      return dates.returnItemsForTomorrow(this.tasks, 'due_at');
    },
    upcomingTasks() {
      return dates.returnItemsUpcoming(this.tasks, 'due_at');
    },
  },
  methods: {
    openEditTaskModal(task) {
      this.$refs.taskModal.open(task);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.timeframe-title {
  margin-bottom: 20px;
  font-size: 1.2rem;
  font-weight: bold;

  i {
    vertical-align: bottom;
  }

  &.past_due {
    color: $red;
  }

  &.today {
    color: $yellow;
  }
}
</style>
